import { render } from "./Deposit.m.vue?vue&type=template&id=cdcee366"
import script from "./Deposit.m.vue?vue&type=script&lang=js"
export * from "./Deposit.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__